/**
 * AdmissionRoutes — the module's route branch (registered as `/admission/*`).
 *
 * Every screen renders inside `AdmissionLayout`, which supplies the shared
 * chrome (Header, sub-navigation, Breadcrumb, Footer) plus the `Suspense` +
 * error boundary for the lazily-loaded screens:
 *
 *   index                          → redirect to Geographic (the module landing)
 *   geographic                     → Geographic drill-down (GeographicAnalysis)
 *   geographic/region/:regionCode  → Region detail (RegionAdmissionDetail)
 *   geographic/kv/:kvCode          → KV detail (KvAdmissionDetail)
 *   *                              → redirect to the module index
 *
 * RTE / Income Group / Distance are no longer routes — they are views inside
 * GeographicAnalysis, sharing its filter and cohort.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdmissionLayout from '../screens/AdmissionLayout';

const GeographicAnalysis = React.lazy(() => import('../screens/GeographicAnalysis'));
const RegionAdmissionDetail = React.lazy(() => import('../screens/RegionAdmissionDetail'));
const KvAdmissionDetail = React.lazy(() => import('../screens/KvAdmissionDetail'));

const AdmissionRoutes: React.FC = () => (
  <Routes>
    <Route element={<AdmissionLayout />}>
      {/* Geographic is the module's landing screen. */}
      <Route index element={<Navigate to="/admission/geographic" replace />} />
      <Route path="geographic" element={<GeographicAnalysis />} />
      <Route path="geographic/region/:regionCode" element={<RegionAdmissionDetail />} />
      <Route path="geographic/kv/:kvCode" element={<KvAdmissionDetail />} />
      {/* Unknown sub-path → redirect to the module index */}
      <Route path="*" element={<Navigate to="/admission" replace />} />
    </Route>
  </Routes>
);

export default AdmissionRoutes;
